import {
	FETCH_ALL_RETAIL_APPS_BEGIN,
	FETCH_ALL_RETAIL_APPS_SUCCESS,
	GET_FILTERED_PACKAGES,
	FETCH_PACKAGES_BEGIN,
	FETCH_PACKAGES_SUCCESS,
	FETCH_PACKAGE_BEGIN,
	FETCH_PACKAGE_SUCCESS,
	ADD_APP_TO_PACKAGE_BEGIN,
	ADD_APP_TO_PACKAGE_SUCCESS,
	REMOVE_APP_FROM_PACKAGE_BEGIN,
	REMOVE_APP_FROM_PACKAGE_SUCCESS
} from '../actions/retailActions';

const defaultAllRetailAppState = {
	retailApps: [],
	pagination: {},
	loading: false,
};

const defaultPackageAppsListState = {
	packageApps: [],
	pagination: {},
	loading: false,
};

const defaultPackagesList = {
	packages: [],
	pagination: {},
	loading: false,
	packages_pagination: {
		numberOfElements : 0,
		totalElements: 0,
		totalPages: 0
	},
};

const defaultFilteredPackagesList = {
	filteredPackages: [],
	pagination: {},
	loading: false,
};

export const retailAppsList = (state = defaultAllRetailAppState, action) => {
	switch (action.type) {
	case FETCH_ALL_RETAIL_APPS_BEGIN:
		return {
			...state,
			loading: true
		};
	case FETCH_ALL_RETAIL_APPS_SUCCESS:
		return {
			...state,
			loading: false,
			retailApps: action.payload.apps,
			pagination: {
				numberOfElements : action.payload.numberOfElements,
				totalElements: action.payload.totalElements,
				totalPages: action.payload.totalPages
			},
		};

	default:
		return state;
	}
};

export const retailPackageAppsList = (state = defaultPackageAppsListState, action) => {
	switch (action.type) {
	case FETCH_PACKAGE_BEGIN:
		return {
			...state,
			loading: true
		};
	case FETCH_PACKAGE_SUCCESS:
		return {
			...state,
			loading: false,
			packageApps: action.payload.packageApps,
			pagination: {
				numberOfElements : action.payload.numberOfElements,
				totalElements: action.payload.totalElements,
				totalPages: action.payload.totalPages
			},
		};

	default:
		return state;
	}
};


export const packagesList = (state = defaultPackagesList, action) => {
	switch (action.type) {
	case FETCH_PACKAGES_BEGIN:
		return {
			...state,
			loading: true
		};
	case FETCH_PACKAGES_SUCCESS:
		return {
			...state,
			loading: false,
			packages: action.payload.packages,
			packages_pagination: {
				numberOfElements : action.payload.numberOfElements,
				totalElements: action.payload.totalElements,
				totalPages: action.payload.totalPages
			},
		};
	default:
		return state;
	}
};

export const filteredPackages = (state = defaultFilteredPackagesList, action) => {
	switch (action.type) {
	case GET_FILTERED_PACKAGES:
		return {
			...state,
			filteredPackages: action.filteredPackages

		};
	default:
		return state;
	}
};

export const changePackageAppsList = (state = [], action) => {
	switch (action.type) {
	case ADD_APP_TO_PACKAGE_BEGIN:
		return {
			...state,
			add_status_loading: true
		};
	case ADD_APP_TO_PACKAGE_SUCCESS:
		return {
			...state,
			add_status_loading: false
		};
	case REMOVE_APP_FROM_PACKAGE_BEGIN:
		return {
			...state,
			remove_status_loading: true
		};
	case REMOVE_APP_FROM_PACKAGE_SUCCESS:
		return {
			...state,
			remove_status_loading: false
		};
	default:
		return state;
	}
};




// WEBPACK FOOTER //
// ./src/reducers/retail.js